import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error", "globalError"]

  async submit(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    let isValid = true

    if (this.hasGlobalErrorTarget) {
      this.globalErrorTarget.textContent = ""
      this.globalErrorTarget.classList.remove('is-visible')
    }

    this.inputTargets.forEach((input) => {
      const fieldContainer = input.closest('.act-field')
      const errorElement = fieldContainer ? fieldContainer.querySelector('[data-activation-target="error"]') : null
      const value = input.value.trim()
      const name = input.name

      if (fieldContainer) fieldContainer.classList.remove('act-field-error')
      if (errorElement) errorElement.textContent = ""

      if (!value) {
        isValid = false
        this.showFieldError(fieldContainer, errorElement, "To pole jest wymagane")
        return
      }

      if (!/^\d+$/.test(value)) {
        isValid = false
        this.showFieldError(fieldContainer, errorElement, "Wprowadź tylko cyfry")
        return
      }

      if (name === "customer_number") {
        if (value.length < 5 || value.length > 6) {
          isValid = false
          this.showFieldError(fieldContainer, errorElement, "Numer klienta musi mieć 5 lub 6 cyfr")
        }
      } 
      else if (name === "identifier") {
        // PESEL ma 11 cyfr, NIP ma 10 cyfr
        if (value.length !== 10 && value.length !== 11) {
          isValid = false
          this.showFieldError(fieldContainer, errorElement, "PESEL (11 cyfr) lub NIP (10 cyfr)")
        }
      }
    })

    if (!isValid) return

    const form = this.element
    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        }
      })

      const contentType = response.headers.get("Content-Type")

      if (response.ok) {
        const data = await response.json()
        if (data.url) window.location.assign(data.url)
        return
      }

      let errorMessage = "Wystąpił nieoczekiwany błąd"
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json()
        errorMessage = data.error || errorMessage
      } else {
        errorMessage = "Usługa tymczasowo niedostępna. Spróbuj za chwilę."
      }

      this.showGlobalError(errorMessage)

    } catch (error) {
      this.showGlobalError("Błąd połączenia z serwerem.")
    }
  }

  showFieldError(container, element, message) {
    if (container && element) {
      container.classList.add('act-field-error')
      element.textContent = message
    }
  }

  showGlobalError(message) {
    if (this.hasGlobalErrorTarget) {
      this.globalErrorTarget.textContent = message.trim()
      this.globalErrorTarget.classList.add('is-visible')
    }
    
    this.element.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(-5px)' },
      { transform: 'translateX(5px)' },
      { transform: 'translateX(0)' }
    ], { duration: 200, iterations: 2 })
  }
}